import { ENDPOINT } from '~/constants';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { type SitesAdminQueryParams, type SitesAdminResponse } from './types';
import {
  zodSitesAdminQueryParamsSchema,
  zodSitesAdminResponseSchema,
} from './validations';

/**
 * Fetches one page of the cross-tenant site directory (vadmin only): name/id
 * search, optional company-account scope, optional single-id lookup.
 *
 * @param queryParameters - Search string, scope, id and page of the listing.
 * @param options - Additional request options (e.g. abort signal).
 * @returns One page of sites in the pagination envelope.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Directory/operation/get_sites_directory_vadmin_site_get
 */
export const fetchSitesAdmin = async (
  queryParameters: SitesAdminQueryParams = {},
  options?: KyRequestOptions,
) =>
  vestigasApi
    .get(ENDPOINT.SITE.GET_ALL_ADMIN(), {
      searchParams: queryParameters,
      ...options,
      validate: {
        ...options?.validate,
        response: zodSitesAdminResponseSchema,
        searchParams: zodSitesAdminQueryParamsSchema,
      },
    })
    .json<SitesAdminResponse>();
